<form class="input-wrapper" [formGroup]="formGroup" [ngClass]="{ 'row-layout': showSearchButton, 'column-layout': !showSearchButton }">
  <div class="search-container" [ngClass]="showSearchButton ? 'with-search' : 'without-search'">
    @for (field of inputConfigs; track field.label; let i = $index; let isLast = $last) {
      <div class="input-container">
        <div class="field-group">
          <p-inputGroup>
            @if (field.type === 'date') {
              <div class="calendar-wrapper" [ngClass]="{ focused: focusedIndex === i }">
                <p-iftalabel class="custom-iftalabel">
                  <p-calendar
                    [id]="'input-' + i"
                    [formControlName]="field.name"
                    (onFocus)="focusedIndex = i"
                    (onBlur)="focusedIndex = null"
                    (onSelect)="emitValues()"
                    (onClear)="emitValues()"
                    [inputId]="'input-' + i"
                    [placeholder]="field.placeholder"
                    [minDate]="dateMode === 'future' ? minDate : null"
                    [maxDate]="dateMode === 'past' ? maxDate : null"
                    [showIcon]="true"
                    inputStyleClass="custom-calendar-input"
                    dateFormat="dd/mm/yy" />
                  @if (field.value) {
                    <button class="clear-btn" type="button" (click)="clearInput(i)">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  }
                  <label [for]="'input-' + i">{{ field.label }}</label>
                </p-iftalabel>
              </div>
            } @else {
              <p-iftalabel class="custom-iftalabel">
                <input
                  pInputText
                  [id]="'input-' + i"
                  [placeholder]="field.placeholder"
                  [type]="field.type"
                  [formControlName]="field.name"
                  (input)="emitValues()" />

                @if (field.value) {
                  <button class="clear-btn" type="button" (click)="clearInput(i)">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                }
                <label [for]="'input-' + i">{{ field.label }}</label>
              </p-iftalabel>
            }
          </p-inputGroup>
        </div>

        @if (showErrors) {
          <app-input-field-error [control]="formGroup.get(field.name)" [fieldName]="field.name" class="input-error-message"> </app-input-field-error>
        }
        @if (!isLast) {
          <div class="separator"></div>
        }
      </div>
    }
  </div>

  @if (showSearchButton) {
    <button pButton type="submit" class="search-button" (click)="emitValues()">
      <i class="fa-solid fa-magnifying-glass"></i>
    </button>
  }
  @if (showSaveButton && !isMobile) {
    <button pButton type="button" class="save-button" (click)="manualSave()">
      <i class="fa-solid fa-floppy-disk"></i>
    </button>
  }

  <div class="field-feedback">
    @if (autosave && isMobile) {
      <p class="save-status" [class.visible]="saveStatus !== 'idle'" [class.success]="saveStatus === 'saved'">
        {{ saveStatus === 'saving' ? 'Enregistrement...' : saveStatus === 'saved' ? 'Enregistré ✅' : '' }}
      </p>
    }
  </div>
</form>
